<template>
  <thead>
    <tr
      class="border-b border-zinc-200/70 text-xs font-semibold uppercase tracking-wide text-zinc-400 dark:border-zinc-800"
    >
      <th
        v-if="shouldShowCheckboxes"
        class="td-fit ps-5 pe-5 py-4"
        :class="{
          'border-r border-zinc-200/70 dark:border-zinc-800':
            shouldShowColumnBorders,
        }"
      >
        <span class="sr-only">{{ __('Selected Resources') }}</span>
      </th>

      <th
        v-for="(field, index) in fields"
        :key="field.uniqueKey"
        :class="{
          [`text-${field.textAlign}`]: true,
          'border-r border-zinc-200/70 dark:border-zinc-800':
            shouldShowColumnBorders,
          'ps-5 pe-5 py-4': true,
          'whitespace-nowrap': !field.wrapping,
        }"
      >
        <SortableIcon
          v-if="sortable && field.sortable"
          @sort="requestOrderByChange(field)"
          @reset="resetOrderBy(field)"
          :resource-name="resourceName"
          :uri-key="field.sortableUriKey"
        >
          {{ field.indexName }}
        </SortableIcon>

        <span v-else>{{ field.indexName }}</span>
      </th>

      <th class="ps-5 pe-5 py-4 text-end">
        <span class="sr-only">{{ __('Controls') }}</span>
        <span aria-hidden="true">{{ __('Actions') }}</span>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: 'ResourceTableHeader',

  emits: ['order', 'reset-order-by'],

  props: {
    resourceName: String,
    shouldShowColumnBorders: Boolean,
    shouldShowCheckboxes: Boolean,
    fields: {
      type: [Object, Array],
    },
    sortable: Boolean,
  },
  methods: {
    requestOrderByChange(field) {
      this.$emit('order', field)
    },

    resetOrderBy(field) {
      this.$emit('reset-order-by', field)
    },
  },
}
</script>
